import React, { useEffect, useState } from "react";
import Input from "../modules/Input";
import Button from "../modules/Button";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useDispatch, useSelector } from "react-redux";
import { addCandidateInfo, addCandidatePage } from "./redux/actions";
import { registrationAPI } from "./SampleJson";
import { api } from "../../Services";
import TransitionAlerts from "../modules/Alerts";
import { useNavigate } from "react-router-dom";

function Verification() {
  const [valid, setValid] = useState(false);
  const navigate = useNavigate();

  const [info, setInfo] = useState({
    email: "",
    eOtp: "",
    mobile: "",
    mOtp: "",
  });
  const [alertType, setAlertType] = useState({ msg: "", type: "" });
  const [alert, setAlert] = useState(false);

  const [type, setType] = useState({ type: "mobile", content: "number" });
  const dispatch = useDispatch();
  const registeredData = useSelector((state) => state.register.registeredData);

  const editText = () => {
    return (
      <div className="edit-text">
        <span className="left-edit">
          We have sent an OTP to{" "}
          {type.type === "mobile" ? info.mobile : info?.email}
        </span>
        <span
          onClick={() => setType({ ...type, content: "number" })}
          className="pointer right-edit"
        >
          Edit
        </span>
      </div>
    );
  };

  const nextField =async () => {
  
    const users = await  makeRegister();
      let url = GetBaseUrl(window.location.href);
      console.log("users", users);
      if(users.statusCode== '200'){
        // window.location.replace(url);
        navigate('/');

      }
  };

 

  const filterInput = (data) => {
    let info1 = { ...info };
    let isError = true;

    if (type.content === "otp") {
      data = data?.replace(/\D/g, "");
      if (data?.length > 5) {
        data = data?.slice(0, 6);
        isError = false;
      } else if (data?.length < 6) {
        isError = true;
      }
      if (type?.type === "mobile") {
        info1.mOtp = data;
      } else {
        info1.eOtp = data;
      }
    } else if (type?.type === "mobile") {
      data = data.replace(/\D/g, "");
      if (data?.length > 9) {
        data = data.slice(0, 10);
        isError = false;
      } else if (data?.length < 10) {
        isError = true;
      }
      info1.mobile = data;
    } else {
      if (info1.email) {
        info1.email = data;
      }
      const pinRegex = /^([a-zA-Z0-9._-]+)@([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,4})$/;
      isError = !pinRegex.test(data);
    }
    console.log("is error", isError);
    setValid(!isError);
    setInfo({ ...info1 });
  };
  const makeRegister = async () => {
    registrationAPI.registration.email = registeredData?.info?.email;
    registrationAPI.registration.password = registeredData?.info?.password;
    registrationAPI.registration.source = registeredData?.info.source;
    registrationAPI.registration.college = registeredData?.info.college;
    registrationAPI.registration.degree = registeredData?.info.degree;
    registrationAPI.registration.year =
      registeredData?.info.year || "2024-2026";
    registrationAPI.registration.income = registeredData?.info.income;
    registrationAPI.registration.family = registeredData?.info.family;
    registrationAPI.registration.indian = registeredData?.info.indian;
    registrationAPI.registration.aadhaar = registeredData?.info.aadhar;
    registrationAPI.application.personalInfo = { ...registeredData?.basicInfo };
    const data = { ...registrationAPI };
    try {
      const users = await api.createUser(data);
      
      return users;
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      if (error.statusCode == "403") {
        // alert(error.message)
        setAlertType({
          msg: "Sorry! Something went wrong, Please connect with administrater",
          type: "otp",
        });
        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
      }else if (error.statusCode == "500") {
        // alert(error.message)
        setAlertType({
          msg: error.data,
          type: "otp",
        });
        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
      }else{
        setAlert(true);
        setAlertType({
          msg: "Registration not successfull",
          type: "otp",
        });
        setTimeout(() => setAlert(false), 3000);
      }
      
      return error;
      // Handle error scenario
    }
  };
  const dispatchData=(type,e)=>{
    dispatch(addCandidateInfo([type, e]))
  }
  useEffect(() => {
    // console.log("valid changed", valid);
  }, [registeredData?.info]);
  console.log("register", registeredData);
  return (
    <div className="cred-section verification">
      <span className="title">Sign up</span>
      {/* <span className="sub-title">
        {type.content === "otp"
          ? editText()
          : `You will receive an OTP on your ${type.type}`}
      </span> */}

      <div className="cred-fields">
        {/* <Input
          onChange={filterInput}
          inputType={type.type === "mobile" &&type.content === "number" && "rupee"}
          placeholder={
            ""
          }
          value={
            type.type === "mobile"
              ? type.content === "number"
                ? info.mobile
                : info.mOtp
              : type.content === "number"
              ? info.email
              : info.eOtp
          }
          // setValid={(e) => setValid(e)}
          // onChange={(e) => setVal(e)}
          id={
            type.content === "number"
              ? type.type === "email"
                ? "email"
                : "mobile"
              : "otp"
          }
        /> */}
        <Input
          onChange={(e) => dispatchData("email", e)}
          // inputType={type === "mobile" && "rupee"}
          value={registeredData?.info?.email}
          placeholder={"Enter Username"}
          // setValid={(e) => setValid(e)}
          // onChange={filterInput}
          // id={type === "mobile" ? "mobile" : "otp"}
        />
        <Input
          onChange={(e) => dispatchData(addCandidateInfo(["password", e]))}
          // inputType={type === "mobile" && "rupee"}
          value={registeredData?.info?.password}
          placeholder={"Enter password"}
          // setValid={(e) => setValid(e)}
          // onChange={filterInput}
          type={"password"}
          // id={[type === "mobile" ? "mobile" : "otp"]}
        />
        {alert && <div className="warning-msg" style={{color:"red", textAlign:'left'}}>Username already exists</div>}
        {/* <Input type={"password"} placeholder={"Password"} /> */}
        {/* <TransitionAlerts
          isAlert={alert}
          message={alertType.msg }
        /> */}
      </div>
      <div className="cred-btn">
        <Button
          disabled={
            registeredData?.info?.email === "" ||
            registeredData?.info?.password === ""
          }
          value={"Next"}
          type={"contained"}
          onClickHandler={nextField}
        />
        {/* <Button value={type === "mobile"? "Sign up" : 'Resend OTP'} type={type === "mobile"? "outlined": 'only-text'} /> */}

        {/* <Button value="Log in" type={"outlined"} />
  <Button value="Forgot Password" type={"only-text"} /> */}
      </div>
    </div>
  );
}

export default Verification;
